export interface FilterChipOption<T extends string = string> {
  value: T;
  label: string;
}

export interface FilterChipsProps<T extends string = string> {
  options: FilterChipOption<T>[];
  selected: T;
  onChange: (value: T) => void;
  label?: string;
}

/** Primitive 10: Filter chips (used in right panel, RPM, RRM). */
export function FilterChips<T extends string = string>({
  options,
  selected,
  onChange,
  label,
}: FilterChipsProps<T>): JSX.Element {
  return (
    <div className="f-chip-row" role="tablist" aria-label={label}>
      {options.map((opt) => {
        const isOn = opt.value === selected;
        return (
          <button
            key={opt.value}
            type="button"
            className={`f-chip ${isOn ? 'is-on' : ''}`}
            role="tab"
            aria-selected={isOn}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
